import React, { lazy, memo, Suspense } from 'react';

import LoaderHoi from 'components/LoaderHoi';

const RichText = lazy(() => import('./RichTextAdapter'));

const LazyRichText = memo((props) => {
    return (
        <Suspense fallback={<LoaderHoi size="big" />}>
            <RichText {...props} />
        </Suspense>
    );
});

LazyRichText.displayName = 'LazyRichText';

export default LazyRichText;
